import React from 'react';
import SingleQuiz from '../Quiz/SingleQuiz';

const QuizzesMainSection = ({ quizzes, isSubmitLoading, handleSubmit, setQuizResult, isEditQuizMarkLoading }) => {
    return (
        <section className="py-6 bg-primary">
            <div className="mx-auto max-w-7xl px-5 lg:px-0">
                <div className="mb-8">
                    <h1 className="text-2xl font-bold">Quizzes for "{quizzes[0].video_title}"
                    </h1>
                    <p className="text-sm text-slate-200">Each question contains 5 Mark</p>
                </div>
                <div className="space-y-8 ">
                    {

                        quizzes.map((single, i) => <SingleQuiz setQuizResult={setQuizResult} index={i + 1} key={single.id} {...single}></SingleQuiz>)
                    }
                </div>

                <button
                    disabled={isSubmitLoading || isEditQuizMarkLoading}
                    onClick={handleSubmit}
                    className="submit-button">Submit</button>
            </div>
        </section>
    );
};

export default QuizzesMainSection;